import { Option } from 'types';

import { Select } from 'components/Select';

import { useClosedBudgetExport } from './ClosedBudgetExport.hooks';
import * as S from './ClosedBudgetExport.styles';

export function ClosedBudgetExport(): React.ReactElement | null {
  const { isAdmin, seasonOptions, seasonSet, download, isLoading, refreshClosedCounts } =
    useClosedBudgetExport();

  if (!isAdmin) {
    return null;
  }

  return (
    <S.Wrapper>
      <S.SeasonSelect>
        <Select
          options={seasonOptions}
          isSearchable={false}
          onChange={(option: Option) => seasonSet(String(option.value))}
          // budgets get sent and reopened meanwhile, so the counts are reloaded on every open
          onMenuOpen={refreshClosedCounts}
        />
      </S.SeasonSelect>

      <S.ExportButton
        motive="secondaryBlack"
        scale="lg"
        iconLeft="FiDownload"
        fontFamily="LFT Zeno Condensed"
        textTransform="uppercase"
        disabled={isLoading}
        onClick={download}
      >
        Export CSV
      </S.ExportButton>
    </S.Wrapper>
  );
}
